import { type EntityResponse, responseStatusEnum } from '@/shared/types/api';
import type { TEvent, TEvents } from './../types';
import useRequest from '@/shared/composables/use-request';
// import { parse } from 'valibot';
// import { eventScheme } from './schemes';

class Event {
	async fetchCurrentEvent(): EntityResponse<TEvent> {
		try {
			const response = await useRequest().$get('/other/event-calendar-current/');

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return response.data;
		} catch (error) {
			throw new Error('error event service');
		}
	}

	async fetchEvents(): EntityResponse<TEvents> {
		try {
			const response = await useRequest().$get('/other/event-calendar/');

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return response.data;
		} catch (error) {
			throw new Error('error event service');
		}
	}
}

export default new Event();
